import PropTypes from 'prop-types'
import React from 'react'
import styled from 'styled-components'

const StyledComponent = styled(({css, ...rest}) => <div {...rest} />)`
    margin-bottom: ${p => p.theme.l};
    border-radius: 3px;
    overflow: hidden;
    border: ${p => p.theme.border_line};
    border-width: thin;
    box-shadow: ${p => p.theme.shadow};

    pre {
    background: #f8f8f8;
    outline: 1px solid #ccc;
    padding: 5px;
    margin: 0;
    white-space: pre-wrap;
    }
    .string { color: green; }
    .number { color: darkorange; }
    .boolean { color: blue; }
    .null { color: magenta; }
    .key { color: red; }
    .title {
      background: #ddd;
      padding: .42em;
      margin: 0;
      outline: 1px solid #ccc;
    }
    .error {
      outline: 1px solid #ccc;
      color: darkred;
      padding: 5px;
    }

  ${p => p.css};
`

const _PrintRWrapper = (props) => <StyledComponent {...props} />
_PrintRWrapper.propTypes = {
  css: PropTypes.oneOfType(
    [
      PropTypes.string,
      PropTypes.array
    ]
  ),
}

export default _PrintRWrapper

